import React from "react";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";

const MenuItems = ({
  products,
  cart,
  selectedSizes,
  setSelectedSizes,
  addToCart,
  updateQty,
}) => {
  return (
    <Card
      style={{
        borderRadius: 8,
        boxShadow: "none",
      }}
    >
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h5 className="fs-16 mb-0">
          Menu Items
        </h5>
      </CardHeader>

      <CardBody>
        <Row className="g-3">
          {products.map((item) => {
            const selectedSize =
              selectedSizes[item._id] || "FULL";

            const cartItem = cart.find(
              (c) =>
                c._id === item._id &&
                c.size === selectedSize
            );

            const qty = cartItem
              ? cartItem.quantity
              : 0;

            return (
             <Col md={4} lg={3} key={item._id}>
  <Card
    style={{
      borderRadius: 8,
      border: "1px solid #efefef",
      background: "#fff",
      boxShadow: "none",
    }}
  >
    <CardBody
      style={{
        padding: 12,
      }}
    >
      {/* ======================
          TOP: NAME + FOOD TYPE
      ====================== */}

      <div
        className="
          d-flex
          justify-content-between
          align-items-start
          mb-2
        "
      >
        {/* FOOD NAME */}

        <div
          style={{
            flex: 1,
            paddingRight: 8,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {item.name?.en}
          </div>

          {item.name?.hi && (
            <div
              style={{
                fontSize: 11,
                color: "#6c757d",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item.name?.hi}
            </div>
          )}
        </div>

        {/* VEG / NON VEG */}

        <div
          className="d-flex align-items-center"
          style={{
            gap: 5,
            fontSize: 11,
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          <span>
            {item.type === "Veg"
              ? "Veg"
              : "Non Veg"}
          </span>

          <div
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background:
                item.type === "Veg"
                  ? "green"
                  : "red",
            }}
          />
        </div>
      </div>

      {/* ======================
          IMAGE SECTION
      ====================== */}

      <div
        style={{
          marginBottom: 12,
        }}
      >
        <img
          src={
            item.image ||
            "https://via.placeholder.com/400x250?text=Food"
          }
          alt={item.name?.en || "Food"}
          style={{
            width: "100%",
            height: "100%",

            /* Image remains inside padded card */
            objectFit: "contain",

            display: "block",

            borderRadius: 8,
          }}
        />
      </div>

      {/* ======================
          PRICE + QUANTITY
      ====================== */}

      <div
        className="
          d-flex
          justify-content-between
          align-items-center
        "
      >
        {/* PRICE */}

        <div
          style={{
            fontSize: 15,
            fontWeight: 700,
          }}
        >
          ₹{item.price}
        </div>

        {/* QUANTITY */}

        <div
          style={{
            width: 100,
            height: 36,
            borderRadius: 6,
            background: "#f3f3f3",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 12px",
          }}
        >
          {/* MINUS */}

          <div
            onClick={() => {
              if (qty > 0) {
                const index =
                  cart.findIndex(
                    (c) =>
                      c._id === item._id &&
                      c.size === selectedSize
                  );

                if (index > -1) {
                  updateQty(
                    index,
                    "DEC"
                  );
                }
              }
            }}
            style={{
              cursor: qty > 0
                ? "pointer"
                : "default",

              fontSize: 20,
              fontWeight: 700,

              color:
                qty > 0
                  ? "#666"
                  : "#ccc",
            }}
          >
            -
          </div>

          {/* QUANTITY */}

          <div
            style={{
              fontWeight: 700,
              fontSize: 14,
              minWidth: 20,
              textAlign: "center",
            }}
          >
            {qty}
          </div>

          {/* PLUS */}

          <div
            onClick={() =>
              addToCart(
                item,
                selectedSize
              )
            }
            style={{
              cursor: "pointer",
              fontSize: 19,
              fontWeight: 700,
              color: "#666",
            }}
          >
            +
          </div>
        </div>
      </div>
    </CardBody>
  </Card>
</Col>
            );
          })}
        </Row>
      </CardBody>
    </Card>
  );
};

export default MenuItems;